import { environment } from './environments/environment';

export const BF_BASE_URL = environment.bfBaseUrl;
export const BF_WEBSITE_BASE_URL = environment.bfWebsiteBaseUrl;
export const BF_STATIC_ASSETS_BASE_URL = environment.bfStaticAssetsBaseUrl;
export const HOST_URL = environment.hostUrl;
export const OAUTH_CLIENT_ID = environment.oauthClientId;
export const OAUTH_BASE_URL = environment.oauthBaseUrl;
export const TEMPORAL_BASE_URL = environment.temporalBaseUrl;
